import React from 'react';
import { motion } from 'framer-motion';

const WatWeUitdragen = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden" style={{ background: '#0D0D0D', borderTop: '1px solid #1A1A1A', borderBottom: '1px solid #1A1A1A' }}>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full blur-[140px] opacity-5" style={{ background: '#00E5A0' }} />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.p
          className="text-xs font-body font-medium tracking-[0.2em] uppercase mb-10 flex items-center gap-3"
          style={{ color: '#00E5A0' }}
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          WAT WE UITDRAGEN <span className="flex-1 h-px" style={{ background: '#2A2A2A' }} />
        </motion.p>

        <motion.blockquote
          className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold leading-tight text-white mb-14 max-w-4xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1, duration: 0.7 }}
        >
          <span className="text-5xl md:text-6xl leading-none" style={{ color: '#00E5A0', fontFamily: 'Georgia, serif' }}>"</span>
          <span>Elke EU-vakman verdient de weg naar de juiste kans. Elke Belgische werkgever verdient personeel dat opdaagt — gecertificeerd, voorbereid, betrokken.</span>
          <span className="text-5xl md:text-6xl leading-none" style={{ color: '#00E5A0', fontFamily: 'Georgia, serif' }}>"</span>
        </motion.blockquote>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px" style={{ background: '#1A1A1A' }}>
          {[
            { value: '340+', label: 'Bedrijven vertrouwen op BVM Group' },
            { value: '8', label: 'Gespecialiseerde sectoren' },
            { value: '10+', label: 'Jaar Belgische expertise' },
          ]?.map((stat, i) => (
            <motion.div
              key={i}
              className="p-8 text-center"
              style={{ background: '#0D0D0D' }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 + i * 0.1 }}
            >
              <p className="text-4xl md:text-5xl font-heading font-bold mb-2" style={{ color: '#00E5A0' }}>{stat?.value}</p>
              <p className="text-sm font-body" style={{ color: '#666666' }}>{stat?.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WatWeUitdragen;
